import React from 'react';
import { NavigationButtonProps, NavigationButtons } from '@molecules/index';
import { ErrorMessages } from '@types';
import {
  RadioOptionsWithImages,
  SingleRadioOptionWithImageProps,
} from './RadioOptionsWithImages';

export interface MultipleOptionsTemplateProps {
  title?: string;
  description?: string;
  labelClassName?: string;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  onChange: (result: string) => void;
  options: Omit<
    SingleRadioOptionWithImageProps,
    'setRadio' | 'onChange' | 'radioIndex'
  >[];
  buttonNext: NavigationButtonProps;
  buttonPrevious: NavigationButtonProps;
  isTitleOnly?: boolean;
}

export const MultipleOptionsTemplate: React.FC<
  MultipleOptionsTemplateProps
> = ({
  title,
  description,
  labelClassName,
  errorPath,
  errorMessages,
  onChange,
  options,
  buttonNext,
  buttonPrevious,
  isTitleOnly = false,
}) => {
  return (
    <div className="flex flex-col gap-[40px]">
      <RadioOptionsWithImages
        title={title}
        description={description}
        className={labelClassName}
        errorPath={errorPath}
        errorMessages={errorMessages}
        onChange={onChange}
        options={options}
        isLabelTextTitle={true}
        isTitleOnly={isTitleOnly}
      />
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </div>
  );
};
